import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    List,
    ListItem,
    Container,
} from "@mui/material";

function Selenium() {
    const [selenium, setSelenium] = useState([]);

    useEffect(() => {
        axios({
            method: "GET",
            url: "/files/testing/selenium.txt",
        }).then((res) => {
            setSelenium(res.data);
        });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            <Box id="selenium" sx={{ mt: 8, mb: 6 }}>
                {/* Title */}
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem",  // mobile (~h4)
                            sm: "2.2rem",  // tablet (~h3)
                            md: "2.8rem",  // laptop (~h3+)
                            lg: "3rem",    // desktop (~h2)
                        },
                    }}
                >
                    Selenium
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", mt: 4 }}>
                    {selenium &&
                        selenium.map((item, index) => (
                            <Box key={index} sx={{ mb: 3, textAlign: "justify" }}>
                                {typeof item === "string" ? (
                                    <Typography
                                        variant="body1"
                                        sx={{ fontFamily: "Raleway, sans-serif" }}
                                    >
                                        {item}
                                    </Typography>
                                ) : (
                                    Object.entries(item).map(([title, content], idx) => (
                                        <Box key={idx} sx={{ mb: 3 }}>
                                            <Typography
                                                variant="h6"
                                                sx={{ color: "#030366", mb: 1, fontWeight: 600 }}
                                            >
                                                {title}
                                            </Typography>
                                            <List>
                                                {content.map((point, i) => (
                                                    <ListItem
                                                        key={i}
                                                        sx={{
                                                            fontFamily: "Raleway, sans-serif",
                                                            display: "list-item",
                                                            pl: 2,
                                                        }}
                                                    >
                                                        {point}
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Box>
                                    ))
                                )}
                            </Box>
                        ))}
                </Box>
            </Box>
        </Container>
    );
}

export default Selenium;
